import indexSignalMapping from "@/views/indexSignalMapping/index_signal_mapping";
import { RequestParamsMaker } from "@/views/indexSignalMapping/scripts/make_request_params";
import axios from "axios";

export async function setBackGroundImage(self: indexSignalMapping) {
  // S3から取得した画像オブジェクトのバイナリをbase64でエンコード
  const reqParams = RequestParamsMaker.makeGetBackgroundImageParams(self.userID);
  const backgroundImageRes = await axios(reqParams);
  const backgroundImageBinary = backgroundImageRes.data.res.signallamp_mapping_background_image.Body.data;
  self.backgroundImage = "data:image/png;base64," + btoa(new Uint8Array(backgroundImageBinary).reduce(function(data, byte) {
    return data + String.fromCharCode(byte)
  }, ""));
}

export function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
